export function Footer() {
  return (
    <footer className='author-container'>
      <p className='subtitle'>Designed and Coded By</p>
      <a
        className='author-name'
        href='https://ccrsxx.github.io/#contact'
        rel='noopener noreferrer'
        target='_blank'
      >
        ccrsxx
      </a>
    </footer>
  );
}
